import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Star } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function ReviewModal({ open, onOpenChange, request, onDone }) {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async () => {
    if (busy || !request) return;
    setBusy(true);
    try {
      await api.post(`/help-requests/${request.id}/review`, { rating, comment });
      toast.success("Değerlendirmeniz gönderildi. Teşekkürler!");
      onDone?.();
      onOpenChange(false);
      setRating(5); setComment("");
    } catch (e) {
      toast.error(formatErr(e.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Hizmet sağlayıcıyı değerlendirin</DialogTitle>
        </DialogHeader>
        <div className="rounded-xl bg-primary/10 border border-primary/40 p-3 text-sm">
          <div className="font-semibold">{request?.business?.name || "—"}</div>
          <div className="text-xs text-muted-foreground">{request?.request_type} · {request?.customer_vehicle_type}</div>
        </div>
        <div className="flex justify-center gap-1 py-2">
          {[1,2,3,4,5].map((n) => (
            <button key={n} type="button" onClick={() => setRating(n)} data-testid={`rv-star-${n}`}>
              <Star className={`w-9 h-9 ${n <= rating ? "fill-primary text-primary" : "text-muted-foreground"}`} />
            </button>
          ))}
        </div>
        <Textarea data-testid="rv-comment" value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Yorumunuz (opsiyonel)" rows={3} />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="rv-later" className="rounded-full">DAHA SONRA</Button>
          <Button onClick={send} disabled={busy} data-testid="rv-submit" className="rounded-full bg-primary text-[hsl(var(--brand-black))] hover:bg-primary/90 font-bold">
            DEĞERLENDİRMEYİ GÖNDER
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
